export default class ViewTimer {
  static getEndDate(obj) {
    const endDateString = obj.data('end-date')
    if (endDateString) {
      const endDate = new Date(endDateString)
      return endDate
    }
  }
  static setVisibility(obj, className) {
    const nowDate = new Date()
    const endDate = this.getEndDate(obj)
    if (!endDate || nowDate <= endDate) {
      obj.addClass(className + '--active')
    }
  }
}
